import { render } from "./FlowPanelHeader.vue?vue&type=template&id=3143f808"
import script from "./FlowPanelHeader.vue?vue&type=script&lang=js"
export * from "./FlowPanelHeader.vue?vue&type=script&lang=js"
script.render = render

export default script